import { CalendarCheckIcon, ClipboardCheckIcon, GraduationCapIcon, ImageIcon, ListChecksIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  items?: string[];
  purpose?: string;
  value: string;
  icon: LucideIcon;
  wide?: boolean;
};

export const bonuses: Bonus[] = [
  {
    number: '01',
    title: 'Kit de 50 Checklists y Formularios de Seguridad e Higiene',
    description: 'Una colección de 50 herramientas listas para utilizar y adaptar en el aula, el taller o la institución.',
    items: [
      'Inspecciones de seguridad',
      'Relevamientos de riesgos',
      'Registros de incidentes',
      'Seguimiento de EPP',
      'Control de máquinas',
      'Evaluación de electricidad',
      'Checklists de incendios',
      'Orden y limpieza',
      'Observación de tareas',
      'Investigación de incidentes',
      'Gestión preventiva',
    ],
    purpose: 'evaluar, documentar y mejorar de forma sistemática',
    value: '$16.000 ARS',
    icon: ListChecksIcon,
  },
  {
    number: '02',
    title: 'Kit de Evaluaciones, Rúbricas y Exámenes de Seguridad e Higiene',
    description: 'Un sistema completo para evaluar los aprendizajes en prevención, con distintos formatos y niveles de complejidad.',
    items: [
      'Evaluaciones diagnósticas',
      'Parciales y recuperatorios',
      'Examen integrador',
      'Banco de preguntas',
      'Rúbricas de evaluación',
      'Autoevaluaciones',
      'Herramientas de corrección',
      'Respuestas orientativas',
      'Criterios de competencia',
    ],
    purpose: 'evaluar de forma integral sin crear cada instrumento',
    value: '$15.000 ARS',
    icon: ClipboardCheckIcon,
  },
  {
    number: '03',
    title: 'Banco de 150 Actividades Prácticas de Seguridad e Higiene',
    description: 'Una colección de 150 propuestas listas para implementar durante todo el año lectivo.',
    items: [
      'Análisis visual de escenas de riesgo',
      'Detección de peligros en imágenes',
      'Debates sobre prevención',
      'Desafíos de resolución de problemas',
      'Actividades grupales',
      'Ejercicios de aplicación',
      'Juegos pedagógicos',
      'Estudios de casos',
      'Investigaciones temáticas',
    ],
    purpose: 'tener siempre una actividad disponible sin empezar de cero',
    value: '$14.000 ARS',
    icon: GraduationCapIcon,
  },
  {
    number: '04',
    title: 'Planificación Anual 2026 + Cronograma Docente de Seguridad e Higiene',
    description: 'Un modelo completo para organizar el ciclo lectivo de principio a fin.',
    items: [
      'Planificación anual integrada',
      'Distribución mensual de contenidos',
      'Planificación semanal',
      'Unidades temáticas',
      'Evaluaciones programadas',
      'Proyectos integradores',
      'Fechas de actividades',
      'Seguimiento de competencias',
      'Cronograma de revisión',
    ],
    purpose: 'cerrar tu año lectivo en horas, no en semanas',
    value: '$12.000 ARS',
    icon: CalendarCheckIcon,
  },
  {
    number: '05',
    title: 'Mega Kit Visual de Seguridad e Higiene — 100 Láminas, Infografías y Carteles Imprimibles',
    description:
      'Un conjunto de 100 recursos visuales listos para imprimir, plastificar y colocar en aulas, talleres y laboratorios.',
    items: [
      'Identificación de peligros',
      'Señalización de seguridad',
      'EPP y su uso correcto',
      'Máquinas y zonas peligrosas',
      'Electricidad y riesgos',
      'Prevención de incendios',
      'Ergonomía de puestos',
      'Procedimientos seguros',
      'Emergencias y evacuación',
      'Químicos peligrosos',
      'Agentes biológicos',
      'Orden y limpieza',
      'Carteles motivacionales',
    ],
    purpose: 'proyectar, imprimir y señalizar cada espacio de trabajo',
    value: '$13.000 ARS',
    icon: ImageIcon,
    wide: true,
  },
];
